/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import Config from "data/config";
import { useCurrentDynamicField } from "cms/fields/hooks/use-current-dynamic-field";
import { useSelectFieldSchema } from "cms/fields/hooks/use-select-field-schema";
import { Fragment } from "react";

const FieldDisplayWrapper = (props) => {
    
    const children = props?.children;
    const { field } = useCurrentDynamicField();
    
    // field
    const name = field?.name;
    const settings = field?.settings;
    // const values = field?.values;
    // const type = field?.type;
    // const list = field?.list;
    // const position = field?.position;
    // const canUseDefaults = field?.canUseDefaults;
    // const wasAlreadyDefault = field?.wasAlreadyDefault;
    // const defaultImpl = field?.defaultImpl;

    // field settings
    const hide = settings?.hide ?? false;
    // const style = settings?.style ?? false;
    // const format = settings?.format ?? false;
    // const options = settings?.options ?? false;
    // const applyUnifiedSettings = settings?.applyUnifiedSettings ?? false;

    // schema settings
    const schema = useSelectFieldSchema(name);
    const schemaSettings = schema?.settings;
    const position = schema?.position;
    const label = schemaSettings?.label;
    
    return (
        <Fragment>
            <div className='display-wrapper-field-heading'>
                {position}. {label}
            </div>
            <div className='display-wrapper-field-frame'>
                
                {!hide &&
                    <Fragment>
                        {children}
                    </Fragment>
                }
                
                {hide &&
                    <span className='field-hidden'>This field is not for display</span>
                }
                
                {Config.Debug.useDebug &&
                    <>
                        <div>
                            <details>
                                <summary>Field</summary>
                                <pre style={{ fontSize: "9px", border: "1px solid #999999" }}>
                                    {JSON.stringify(field, null, 2)}
                                </pre>
                            </details>
                            <details>
                                <summary>Settings</summary>
                                <pre style={{ fontSize: "9px", border: "1px solid #999999" }}>
                                    {JSON.stringify(settings, null, 2)}
                                </pre>
                            </details>
                        </div>
                    </>
                }
            </div>
        </Fragment>
    );
};

FieldDisplayWrapper.displayName = "FieldDisplayWrapper";
export { FieldDisplayWrapper };
